/* replacement_request.action (a MySQL SET, so possibly comma-joined) -> readable text. */
export const REPLACEMENT_ACTION_LABELS = {
  SESSION_CANCELLED_BY_TEACHER: 'Cancelled by teacher',
  SESSION_CANCELLED_BY_STUDENT: 'Cancelled by student',
  AUTOMATICALLY_REPLACED: 'Replaced automatically',
  REPLACEMENT_REQUEST_SENT: 'Replacement request sent',
  ACCEPTED_BY_TEACHER: 'Accepted by a teacher',
  SESSION_CANCELLED_BY_TIMEOUT: 'Cancelled: no teacher accepted in time',
  WITHDRAWN_BY_TEACHER: 'Withdrawn by teacher',
  TRANSFERRED_BY_CMS: 'Transferred from Hridaya',
  // set by the expiry job, which closes the request and leaves the class untouched
  SESSION_ALREADY_CANCELLED: 'Class already cancelled',
  REPLACEMENT_NO_LONGER_ACTIVE: 'Class finished or no-show; request closed'
};

// An unknown value is shown as sent, so a new server action is never hidden.
export const replacement_action_label = (action) =>
  String(action || '')
    .split(',')
    .map((a) => a.trim())
    .filter(Boolean)
    .map((a) => REPLACEMENT_ACTION_LABELS[a] || a)
    .join(', ');
